export const config = {
    "name": "投稿统计(本单位)",
    "key": "submissionStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-storage-statistics/manuscript/contributeList",
                "method": "post",
                "params": {
                    // 检索字段
                    // 排序字段
                    order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                    authorName:"",
                    deptIds:"",
                },
                paramsConfig: {
                    size: "pageSize",
                    page: "pageNum",
                    sort: {
                        field: "order",
                        order: {
                            key: "sort",
                            select: {"ascend": 1, "descend": -1}
                        },
                    },
                },
                resConfig: {
                    count: "count",
                    data: "data"
                },
                "defaultParams": {
                    // 检索字段
                    // 排序字段
                    order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                    authorName:"",
                    deptIds:"",
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入姓名",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "authorName",
                            "labelName": "请输入姓名",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_selectTreeDeptById",
                                "config": {
                                    style: {
                                        width: 224
                                    },
                                    searchPlaceholder: '请输入搜索关键词',
                                    treeId: "0",
                                    deleteRootNode: true,
                                    defaultValue: "thisDept",
                                    formatConfig: {
                                        title: "name",
                                        key: "id",
                                        value: "id",
                                        children: "child",
                                    },
                                    maxTagCount: 1
                                }
                            },
                            "placeholder": "请选择收稿单位",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode": "deptIds",
                            "labelName": "请选择收稿单位",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-storage-statistics/manuscript/export/contributeList",
                                        "method": "downloadPost",
                                        "params": {
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["today", "yesterday", "thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 100,
                "columns": [
                    {
                        "title": '序号',
                        "dataIndex": 'index',
                        "width": 100,
                        "key": 'index',
                    },
                    {
                        title: '单位名称',
                        "width": 200,
                        dataIndex: 'deptName',
                        ellipsis: true,
                    },
                    {
                        title: '姓名',
                        "width": 200,
                        dataIndex: 'authorName',
                        ellipsis: true,
                    },
                    {
                        title: '收稿单位名称',
                        "width": 200,
                        dataIndex: 'takeDeptName',
                        ellipsis: true,
                    },
                    {
                        "title": '已提交',
                        "dataIndex": 'submitNumber',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        title: '已投稿',
                        dataIndex: 'contributeNumber',
                        ellipsis: true,
                        sorter: true,

                    },
                    {
                        "title": '已采用',
                        "dataIndex": 'useNumber',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        "title": '采用率',
                        "dataIndex": 'useNumberQuantity',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        "title": '已发布',
                        "dataIndex": 'publishNumber',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        "title": '发布率',
                        "dataIndex": 'publishNumberQuantity',
                        ellipsis: true,
                        sorter: true,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};
